import React from 'react';
import Button from 'common/components/elements/buttons/primary';
import PropTypes from 'prop-types'
import '../style.scss'
import InformationAndPolicies from 'common/components/modules/information-and-policies/sites';
// import Auth from 'sites/utils/Auth';

const VpnBlock = ({ logo, goToHomePage, onClickIntercom, goToSignIn }) => {
   return (
      <div className='flex flex-col items-center justify-center w-full h-full site-block-content text-center px-2 mx-auto'>
         <div className='flex flex-col my-auto items-center'>
            {
               !!logo && (
                  <div className='mb-8 flex'>
                     <img src={ logo } alt='' className=' object-contain object-center w-auto h-14' />
                  </div>
               )
            }
            <span className='text-major font-bold block-big-text dark:text-major-dark'>VPN not allowed</span>
            <span className='text-major text-base leading-tight dark:text-major-dark mt-4'>
               To help prevent fraud, VPN access is not allowed on this site.
            </span>


            <div className='flex justify-center items-center mt-3 h-9'>
               <Button
                  text='Refresh'
                  onClick={ () => {
                     // window.location.reload()
                     goToHomePage()
                  } }
                  borderRadius='large'
                  textSize='base'
                  primaryColor
                  classNames='h-full px-3 text-start'
                  padding='none'
                  iconName='retry'
                  iconPosition='left'
                  backgroundColor='transparent'
               />
            </div>
            <div className='flex justify-center items-center mt-3 h-9'>
               <Button
                  text='Contact support'
                  onClick={ onClickIntercom }
                  borderRadius='large'
                  textSize='base'
                  primaryColor
                  iconName='help-outline'
                  iconPosition='left'
                  textColor='major-dark'
                  fontIconColor='major-dark'
                  classNames='h-full px-3 text-start intercom-frontend-error'
                  // classNames='h-full px-3 text-start intercom-frontend-error'
                  padding='none'
               />
            </div>
            <div className='flex justify-center items-center mt-3 h-9'>
               <Button
                  text='I already have an account - Sign in'
                  onClick={ () => {
                     goToSignIn()
                  } }
                  borderRadius='large'
                  textSize='base'
                  primaryColor
                  classNames='h-full px-3 text-start'
                  padding='none'
                  // iconName='retry'
                  iconPosition='left'
                  backgroundColor='transparent'
               />
            </div>

         </div>
         <InformationAndPolicies />

      </div>
   );
};

VpnBlock.propTypes = {
   logo: PropTypes.string,
   goToHomePage: PropTypes.func,
   onClickIntercom: PropTypes.func,
   goToSignIn: PropTypes.func,
}
export default VpnBlock;
